var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMontantStat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30V37C0 49.7025 10.2974 60 23 60H31.9508H40.9016C53.6041 60 63.9016 49.7025 63.9016 37V30.0148C63.9016 30.0099 63.9016 30.0049 63.9016 30C63.9016 29.9951 63.9016 29.9901 63.9016 29.9852V23C63.9016 10.2975 53.6041 0 40.9016 0H31.9508H23C10.2974 0 0 10.2975 0 23V30Z",
    fill: "#4AD991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3535 40.8889H45.2041C46.119 40.8889 46.8608 41.5853 46.8608 42.4444C46.8608 43.3036 46.119 44 45.2041 44H18.6967C17.7818 44 17.04 43.3036 17.04 42.4444V17.5556C17.04 16.6964 17.7818 16 18.6967 16C19.6117 16 20.3535 16.6964 20.3535 17.5556V40.8889Z",
    fill: "#4AD991"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.5323 34.175C25.9065 34.8017 24.8581 34.8335 24.1906 34.2459C23.5231 33.6583 23.4893 32.6739 24.1151 32.0472L30.3277 25.8249C30.9329 25.2188 31.9386 25.1662 32.6118 25.7056L37.5152 29.6343L43.9039 22.0361C44.4708 21.3618 45.5126 21.2467 46.2308 21.779C46.9489 22.3114 47.0715 23.2895 46.5045 23.9638L39.0493 32.8305C38.467 33.5231 37.3885 33.6227 36.6736 33.0499L31.6636 29.0358L26.5323 34.175Z",
    fill: "#4AD991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontantStat);
export default __webpack_public_path__ + "static/media/montantStat.d7aebfbea07bb4849a7fed892c193d18.svg";
export { ForwardRef as ReactComponent };